require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2013-10-15-docker-ubuntu-on-rackspace.json") })
        }
      }, "path---articles-2013-10-15-docker-ubuntu-on-rackspace");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2013-10-15-docker-ubuntu-on-rackspace!./.cache/json/articles-2013-10-15-docker-ubuntu-on-rackspace.json
// module id = 622
// module chunks = 231608221292675